<template>
  <md-dialog class="confirmListDeleteDialog" :md-active.sync="showDialog">
    <md-dialog-content style="padding-top: 55px; padding-left: 40px; padding-bottom: 30px;" class="pt-40;">
      {{ confirmMessage }}
    </md-dialog-content>
    <md-dialog-actions class="">
      <div class="pr-30 pb-40">
        <md-button
            tabindex="8"
            class="md-raised secondary"
            @click="cancel">
          <strong>{{ options.Lang.zurück }}</strong>
        </md-button>
        <md-button
            class="md-raised md-primary"
            @click="confirm">
          <strong>{{ options.Lang.löschen }}</strong>
        </md-button>
      </div>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
export default {
  name: 'ConfirmListDelete',
  props: {
    options: {
      type: Object,
      required: true
    },
    showDialog: {
      type: Boolean,
      default: false
    },
    confirmMessage: {
      type: String,
      default: 'Are you sure you want to delete this item?'
    },
    itemToDelete: {
      type: Object,
      default: null
    }
  },
  methods: {
    confirm() {
      this.$emit('confirm-delete', this.itemToDelete);
      this.cancel();
    },
    cancel() {
      this.$emit('cancel-delete');
    }
  }
}
</script>

<style lang="scss" scoped>
.confirmListDeleteDialog {
  max-width: 600px !important;
  width: 600px !important;
  margin: 0 auto;
  font-size: 16px;
  padding-bottom: 100px;
}
</style>